import { Component, Prop } from 'vue-property-decorator';
import { Country } from '@/app-modules/localisation-service';
import TombolaBaseComponent from '@/components/base/base.component';

@Component({
  name: 'CountrySelectComponent'
})
class CountrySelectComponent extends TombolaBaseComponent {
  private readonly DEFAULT_COUNTRY = 'UK';
  private readonly DEFAULT_INT_COUNTRY = 'ES';
  private countries: Country[] = [];

  @Prop() public value: string;

  private get selectedCountry(): string {

    if (!this.value || !this.isCountryInCountriesList(this.value)) {
      const isDefaultCountryInCountryList = this.isCountryInCountriesList(this.DEFAULT_COUNTRY);
      this.selectedCountry = (isDefaultCountryInCountryList ? this.DEFAULT_COUNTRY : this.DEFAULT_INT_COUNTRY);
    }
    (async () => await this.setCurrentLanguageByCountryId(this.value))();
    return this.value;
  }

  private set selectedCountry(value: string) {
    this.$emit('input', value);
  }

  private async setCurrentLanguageByCountryId(countryId: string): Promise<void> {
    await this.localisationService.setLangByCountryId(countryId, this.$lang);
  }

  private async mounted(): Promise<void> {
    this.countries = await this.localisationService.getCountries();
  }

  private isCountryInCountriesList(selectedCountry: string): boolean{
    const filteredCountries = this.countries.filter((country) => country.name === selectedCountry || country.langCode === selectedCountry.toLowerCase());
    return filteredCountries.length > 0;
  }
}

export default CountrySelectComponent;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/login/_components/country-select/country-select.component.ts